<template>
  <!-- <v-parallax height="800" fluid src="https://via.placeholder.com/1920x1200"> -->
  <v-container grid-list-xl class="text-xs-center text-sm-left text-md-left">
    <v-layout row wrap>
      <v-flex flex xl8 offset-xl2>
        <v-card class="pa-4" flat>
          <v-form class="text-xs-center poppins contact-form-wrapper">
            <v-layout row wrap>
              <v-flex xs12 sm6 :class="{'pt-0': $vuetify.breakpoint.xsOnly}">
                <v-text-field
                  v-model="fullname"
                  v-validate="'required|min:2'"
                  :error-messages="errors.collect('fullname')"
                  data-vv-name="fullname"
                  label="Name"
                  required
                  prepend-inner-icon="perm_identity"
                  :class="{'pt-0': $vuetify.breakpoint.xsOnly}"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 :class="{'pt-0': $vuetify.breakpoint.xsOnly}">
                <v-text-field
                  v-model="email"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  required
                  label="Email"
                  prepend-inner-icon="mail_outline"
                  :class="{'pt-0': $vuetify.breakpoint.xsOnly}"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 :class="{'pt-0': $vuetify.breakpoint.xsOnly}">
                <v-text-field
                  label="Phone # (e.g. ###-###-####)"
                  id="phone"
                  v-mask="['###-###-####']"
                  v-validate="'required|min:12'" 
                  v-model="phone"
                  :error-messages="errors.collect('phone')"
                  data-vv-name="phone"
                  required
                  prepend-inner-icon="call"
                  :class="{'pt-0': $vuetify.breakpoint.xsOnly}"
                  masked="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 :class="{'pt-0': $vuetify.breakpoint.xsOnly}">
                <v-text-field
                  label="Company (optional)"
                  outlined
                  v-model="company"
                  prepend-inner-icon="location_city"
                  :class="{'pt-0': $vuetify.breakpoint.xsOnly}"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                :class="{'pt-0': $vuetify.breakpoint.xsOnly,'pb-0': $vuetify.breakpoint.xsOnly}"
              >
                <v-textarea
                  v-model="description"
                  name="input-7-4"
                  label="How can we help?"
                  prepend-inner-icon="comment"
                  :class="{'pt-0': $vuetify.breakpoint.xsOnly}"
                  class="pt-3"
                  outlined
                ></v-textarea>
              </v-flex>
            </v-layout>

            <v-btn
              tile
              dark
              color="blue darken-2"
              class="pl-5 pr-5 metropolisMedium contact-button pt-2 pb-2"
              @click.prevent="submit"
            >Send</v-btn>
          </v-form>
          <!-- <v-snackbar
            class="mt-2"
            v-model="snackbar"
            :multi-line="mode === 'multi-line'"
            :timeout="timeout"
            :top="y === 'top'"
            :color="color"
          >
            {{ text }}
            <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
          </v-snackbar>-->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- </v-parallax> -->
</template>

<script>
import axios from "axios";
import qs from "qs";
import { setTimeout } from "timers";
import VueTheMask from 'vue-the-mask';
import Vue from "vue";
Vue.use(VueTheMask)

export default {
  name: "contact_form",
  props: ["formTitle"],
  data() {
    return {
      fullname: "",
      email: "",
      phone: "",
      company: "",
      description: ""

      // snackbar: false,
      // y: "top",
      // mode: "",
      // timeout: 5000,
      // text: "",
      // color: ""
    };
  },
  methods: {
    textTimer() {
      setTimeout(() => {
        this.fullname = "";
        this.email = "";
        this.phone = "";
        this.company = "";
        this.description = "";

        this.formTitle.header = "What can we get started for you?";
        this.formTitle.text =
          "Give us some information, we’ll email or call you within the hour.";
        this.formTitle.icon_name = "";
        this.formTitle.icon_status = false;
        this.formTitle.icon_color = "";
      }, 6000);
    },
    async submit() {
      try {
        let validating = await this.$validator.validateAll();

        if (!validating) return console.log("Unvalidated");

        let formInputs = {
          email: this.email.trim(),
          fullname: this.fullname.trim(),
          phone: this.phone.trim(),
          company: this.company.trim(),
          description: this.description.trim(),
          authorization: "UAIWJV8AEDF2BRRWCVA5"
        };

        const options = {
          method: "POST",
          headers: {
            "content-type": "application/x-www-form-urlencoded"
          },
          data: qs.stringify(formInputs),
          url: "https://notifier.canvasdevelopment.com/sender.php"
        };

        let mail = await axios(options);
        if (mail) {
          this.formTitle.header = "Message Sent";
          this.formTitle.text = "Expect us to reach out to you very soon!";
          this.formTitle.icon_status = true;
          this.formTitle.icon_color = "white";
          this.formTitle.icon_name = "check_circle";

          this.textTimer();
        }
        console.log(mail, "results mail");
      } catch (error) {
        console.log(error, "Error submit");
        this.formTitle.header = "Something went wrong";
        this.formTitle.text = "Please send another message.";
        this.formTitle.icon_status = true;
        this.formTitle.icon_color = "error";
        this.formTitle.icon_name = "change_history";

        this.textTimer();
      }
    }
  }
};
</script>

<style>
.contact-button {
  text-transform: capitalize !important;
  font-size: 14px;
  letter-spacing: 1px;
  border-radius: 0px !important;
}
.contact-form-wrapper .v-icon,
.contact-form-wrapper .v-text-field__slot .v-label,
.contact-form-wrapper .v-messages__message {
  color: #fff !important;
}

.contact-form-wrapper
  .theme--light.v-text-field
  .v-input__control
  .v-input__slot:before {
  border-color: #fff !important;
}
.contact-form-wrapper .theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #fff !important;
}

.v-input__slot .v-text-field__slot input {
  color: white !important;
}

.v-text-field__details .v-messages .v-messages__wrapper .v-messages__message {
  color: #cddc39 !important;
}
</style>
